import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const BlogSection: React.FC = () => {
  const blogPosts = [{
    id: 1,
    title: 'Klanten werven als financieel adviseur: voorbij de via-via',
    category: 'B2B Groei',
    summary: 'Afhankelijk van doorverwijzingen? Ontdek hoe je structureel nieuwe klanten aantrekt buiten je bestaande netwerk. Wij gebruiken hiervoor een data-gedreven aanpak.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    link: '/seo/blog/klanten-werven-financieel-adviseur'
  }, {
    id: 2,
    title: 'Waarom data-gedreven marketing werkt voor kleine B2B-bedrijven',
    category: 'Strategie',
    summary: 'Geen budget om te gokken? Ontdek waarom eerst testen en dan bouwen de slimste investering is voor bedrijven met 1-5 medewerkers.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    link: '/seo/blog/data-gedreven-marketing-mkb'
  }, {
    id: 3,
    title: 'Je website als vangnet: waarom een visitekaartje-site niet genoeg is',
    category: 'Websites',
    summary: 'Een mooie website is niet genoeg. Ontdek waarom je website moet functioneren als een vangnet dat actief klanten binnenhaalt.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    link: '/seo/blog/website-als-vangnet'
  }];
  return <div className="w-full bg-white py-20 md:py-24" data-id="element-83">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-84">
        {/* CTA Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-[#E6F2FF] to-[#F0F4F8] rounded-2xl p-8 md:p-12 text-center mb-16 shadow-sm" data-id="element-85">
          <h3 className="font-bold text-[#111827] mb-3 text-2xl" data-id="element-86">
            Wil je leren hoe je online groeit buiten je netwerk?
          </h3>
          <p className="text-[#6B7280] text-lg mb-6 max-w-2xl mx-auto" data-id="element-87">
            In onze bibliotheek vind je praktische artikelen over SEO,
            klantacquisitie en data-gedreven groei voor B2B-bedrijven.
          </p>
          <motion.a href="/bibliotheek" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-3 px-8 rounded-lg transition duration-300 shadow-md hover:shadow-lg" data-id="element-88">
            Bekijk onze bibliotheek
            <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-89" />
          </motion.a>
        </motion.div>

        {/* Blog Posts Grid */}
        <div className="mb-12 text-center" data-id="element-90">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-91">
            Laatste blogposts
          </motion.h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-92">
          {blogPosts.map((post, index) => <motion.a key={post.id} href={post.link} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-93">
              {/* Featured Image */}
              <div className="relative h-48 overflow-hidden" data-id="element-94">
                <img src={post.image} alt={`${post.title} - zakelijke website laten maken blog`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-95" />
                {/* Category Label */}
                <div className="absolute top-4 left-4" data-id="element-96">
                  <span className="bg-[#007AFF] text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-97">
                    {post.category}
                  </span>
                </div>
              </div>
              {/* Content */}
              <div className="p-6" data-id="element-98">
                <h3 className="font-bold text-[#111827] mb-3 text-xl line-clamp-2 group-hover:text-[#007AFF] transition-colors" data-id="element-99">
                  {post.title}
                </h3>
                <p className="text-[#6B7280] mb-4 line-clamp-3 leading-relaxed" data-id="element-100">
                  {post.summary}
                </p>
                <div className="flex items-center text-[#007AFF] font-medium group-hover:underline" data-id="element-101">
                  Lees verder
                  <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-102" />
                </div>
              </div>
            </motion.a>)}
        </div>

        {/* Meer artikelen CTA */}
        <div className="mt-12 text-center" data-id="element-103">
          <motion.a href="/bibliotheek" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center bg-white border-2 border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF] hover:text-white font-semibold py-3 px-8 rounded-lg transition duration-300 shadow-sm hover:shadow-md" data-id="element-104">
            Meer artikelen bekijken
            <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-105" />
          </motion.a>
        </div>
      </div>
    </div>;
};